import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=4ace9b56&scoped=true&"
var script = {}
import style0 from "./Carousel.vue?vue&type=style&index=0&id=4ace9b56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ace9b56",
  null
  
)

export default component.exports